module.exports = __webpack_public_path__ + "static/20200804_154614-bc5ccee31883c65202cc0229bc69ef68.jpg";